export default function getLoginToken() {
  return window.localStorage.getItem("token");
}
